import { type AnnualConsumption } from "../types/annualConsumption"
import { isPeakOffPeakAnnualConsumption } from "./typeguard"

export function getTotalAnnualConsumption(consumption: AnnualConsumption) {
    if (isPeakOffPeakAnnualConsumption(consumption)) {
        return consumption.peak + consumption.offPeak
    }

    return consumption.allDay
}
